<template>
<header class="header section" v-bind:class="{'header_opened' : show}" id="header">
  <div class="header__container section__container">
    <a class="header__burger">
      <span v-if="!show" v-on:click="show = !show"
            class="header__burger-open">
        <MenuIcon />
      </span>
      <span v-if="show" v-on:click="show = !show"
            class="header__burger-close">
        <CloseIcon />
      </span>
    </a>
    <a class="header__logo" v-scrollTo="'header'">Ferma</a>
    <span class="header__logo-partner">
      <img src="../../assets/images/rsb.png"
           srcset="../../assets/images/rsb@2x.png 2x"
           alt="Банк Русский стандарт"
           class="pc"/>
      <img src="../../assets/images/rsb.svg"
           alt="Банк Русский стандарт"
           class="mob"/>
    </span>
    <nav class="header__menu" v-bind:class="{'header__menu_opened' : show}">
      <ul class="header__menu-list">
        <li class="header__menu-item">
          <a class="header__menu-link"
             v-scrollTo="'integration'"
             v-on:click="show = !show">Интеграции</a>
        </li>
        <li class="header__menu-item">
          <a class="header__menu-link"
             v-scrollTo="'tariffs'"
             v-on:click="show = !show">Тарифы</a>
        </li>
        <li class="header__menu-item">
          <a class="header__menu-link"
             v-scrollTo="'calc'"
             v-on:click="show = !show">Подключиться</a>
        </li>
        <li class="header__menu-item">
          <a class="header__menu-link"
             v-scrollTo="'about'"
             v-on:click="show = !show">О компании</a>
        </li>
      </ul>
    </nav>
    <div class="header__contacts">
      <a href="tel:+74955409911" class="header__phone">
        <span class="header__phone-pc">+ 7 (495) 540-99-11</span>
        <span class="header__phone-mob">
          <img src="../../assets/images/phone.svg" alt="">
        </span>
      </a>
      <a href="mailto:rsb-ferma@ofd.ru" class="header__email">
        <img src="../../assets/images/email.svg" alt="">
      </a>
    </div>
  </div>
</header>
</template>

<script>
import MenuIcon from 'vue-material-design-icons/Menu.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';

export default {
  name: 'Header',
  data() {
    return {
      show: false,
    }
  },
  components: {
    MenuIcon,
    CloseIcon,
  }
}
</script>

<style src="./component.scss" scoped lang="scss"/>
